import Vue from 'vue'
import Router from 'vue-router'
import Pay from '@/components/Pay'
import PayResult from '@/components/payResult'
import AboutUs from '@/components/aboutUs'
import BusinessIntr from '@/components/businessIntr'
import UserAgreement from '@/components/userAgreement'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/payResult',
      name: 'PayResult',
      component: PayResult
    },{
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/businessIntr',
      name: 'businessIntr',
      component: BusinessIntr
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: UserAgreement
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js